import { useMemo } from 'react';

import LayoutMain from '@Layouts/LayoutMain';
import PageTopBar from '@Components/PageTopBar';
import LogoTrends from '@Components/LogoTrends';
import usePage from '@Queries/usePage';
import useTranslation from '@Queries/useTranslation';
import usePromotions from '@Queries/usePromotions';
import CurrentPromotions from './elems/CurrentPromotions';
import CurrentDiscounts from './elems/CurrentDiscounts';
import GallerySection from '@Components/GallerySection';
import Button from '@UI/Button';
import CategoryCard from './elems/CategoryCard';
import ProductsSection from '@Components/ProductsSection';
import Page from '@Components/Page';
import styles from './PagePromotionDiscounts.module.css';

import type { FC } from 'react';
import type { PagePromotionsDiscountsData } from './typings';

const PagePromotionsDiscounts: FC = () => {
  const { data: page } = usePage<PagePromotionsDiscountsData>();
  const { data: promo } = usePromotions({ listName: 'promotions-and-discounts', type: 'card' });
  const { t } = useTranslation();

  const cards = useMemo(() => (promo || []).map((item) => item.materials[0]), [promo]);

  return (
    <LayoutMain>
      <Page>
        <PageTopBar title={page.meta.h1} breadcrumbs={page.breadcrumbs} />
        <div className={styles.page} data-testid='page-promotions-discounts'>
          {cards.length > 0 && <CurrentPromotions title={t('current-promo')} promotions={cards} />}

          {page.offerCategories?.length > 0 && (
            <CurrentDiscounts title={t('current-discounts')} categories={page.offerCategories} />
          )}

          {!!page.trends && (
            <>
              <div>
                <LogoTrends className={styles.logoTrends} />
                <GallerySection
                  title={page.trends.title}
                  defaultGap
                  defaultSizes
                  slides={page.trends.list}
                  renderSlide={(category) => <CategoryCard category={category} />}
                />
              </div>

              <div>
                <ProductsSection title={t('top-products')} products={page.trends.products} />
                <div className={styles.buttonWrapper}>
                  <Button className={styles.button} theme='dirty' to='/category/promo-bud-v-trende'>
                    {t('ui.watch-more')}
                  </Button>
                </div>
              </div>
            </>
          )}
        </div>
      </Page>
    </LayoutMain>
  );
};

export default PagePromotionsDiscounts;
